import { ApiConfig } from "../../../../config"
import { TimerData, StopTimerData } from "../../../../models/TimeTracking"
import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes"
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk"
import { Dispatch } from 'redux';
import { AppStateWithData } from '../../../AppStateWithData';

export const getCurrentTimeActionTypes = createRequestActionTypes("GET_CURRENT_TIME_TRACKING")
export const stopTimeActionTypes = createRequestActionTypes("STOP_TIME_TRACKING")
export const startTimeActionTypes = createRequestActionTypes("START_TIME_TRACKING")
export const editTimeActionTypes = createRequestActionTypes("EDIT_TIME_TRACKING")

export const SET_CURRENT_TIME = 'SET_CURRENT_TIME'
export const SET_TIME_TRACKING_TASK = 'SET_TIME_TRACKING_TASK'
export const ACTIVATE_TIMER = 'ACTIVATE_TIMER'
export const DISABLED_TIMER  = 'DISABLED_TIMER '
export const SET_ACTIVE_TASK_ID = 'SET_ACTIVE_TASK_ID'

export interface TimeTrackingAction {
    type: string
}

export interface SetActiveTaskIdAction  {
    type: string
    payload?: string
}

export interface SetCurrentTimeAction  {
    type: string
    payload?: Date | null
}

export interface TimeTrackingTaskAction  {
    type: string
    payload?: Document
}

export const getCurrentTimeTracking = (config: ApiConfig) => {
    const thunkParams: RequestThunkParameters<TimerData > = {
        method: 'GET',
        requestActionTypes: getCurrentTimeActionTypes,
        url: `${config.API_URL}/timetracking`
    }
    return createRequestThunk(thunkParams)
}

export const stopTimeTracking = (config: ApiConfig) => {
    const thunkParams: RequestThunkParameters<StopTimerData> = {
        method: 'GET',
        requestActionTypes: stopTimeActionTypes,
        url: `${config.API_URL}/timetracking/stop`
    }
    return createRequestThunk(thunkParams)
}

export const startTimeTracking = (config: ApiConfig) => (docId: string) =>  {
    const thunkParams: RequestThunkParameters<TimerData> = {
        method: 'GET',
        requestActionTypes: startTimeActionTypes,
        url: `${config.API_URL}/timetracking/start?docId=${docId}`
    }
    return createRequestThunk(thunkParams)
}

export const editTimeTracking = (config: ApiConfig) => (taskId: string, taskName: string) => async (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<TimerData> = {
        method: 'GET',
        requestActionTypes: editTimeActionTypes,
        url: `${config.API_URL}/timetracking/update?taskId=${taskId}&taskName=${taskName}`
    }
    dispatch<any>(createRequestThunk(thunkParams))
}

export function setTimeTrackingTask(timeTrackingTask : any): TimeTrackingTaskAction {
    return { 
        type: SET_TIME_TRACKING_TASK,
        payload: timeTrackingTask,
    }
}

export function setActiveTaskId(id: string): SetActiveTaskIdAction {
    return { 
        type: SET_ACTIVE_TASK_ID,
        payload: id,
    }
}

export function setCurrentTime(currentTime: Date | null): SetCurrentTimeAction {
    return { 
        type: SET_CURRENT_TIME, 
        payload: currentTime,
    }
}

export function activateTimer():  TimeTrackingAction {
    return { type: ACTIVATE_TIMER }
}

export function disabledTimer(): TimeTrackingAction {
    return { type: DISABLED_TIMER }
}